module.exports = __webpack_public_path__ + "static/img/back2.0379724.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page3/back2.png
// module id = NcNy
// module chunks = 0